import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

export function Border(props) {
  const setClass = (cls) => `${cls} ${props.className}`;

  return (
    <>
      <div key="boxOne" className={setClass(style.box_one)} />
      <div key="boxTwo" className={setClass(style.box_two)} />
      <div key="boxThree" className={setClass(style.box_three)} />
    </>
  );
}

Border.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
};

Border.defaultProps = {
  className: "",
};
